import {Entity} from '@s-ui/domain'

import {TransactionError} from '../Errors/TransactionError.js'

export class TradeEntity extends Entity {
  /**
   * @constructor
   * @param {Number} agreedPrice
   * @param {String} id
   * @param {String} buyerName
   * @param {String} sellerName
   */

  static validate({id}) {
    if (!id) throw TransactionError.create(`[TradeEntity.validate] id is required`)
  }

  static create({agreedPrice, buyerId, buyerName, id, sellerId, sellerName}) {
    TradeEntity.validate({id})
    return new TradeEntity({agreedPrice, buyerId, buyerName, id, sellerId, sellerName})
  }

  getAgreedPrice() {
    return this._agreedPrice
  }

  getId() {
    return this._id
  }
}
